import { Component, OnInit, OnDestroy } from '@angular/core';


// Services.
import { DataService } from '../../services/data/data.service';
import { LoggerService } from '../../services/logger/logger.service';


// Clases.
import { IndexItem } from '../../classes/indexItem';
import { Logger } from '../../classes/logger';
import { BookIndexFrame } from '../../classes/bookIndexFrame';
import { Subscription } from 'rxjs';
import { LanguageService } from '../../services/lang/language.service';
import { mergeMap, tap } from 'rxjs/operators';


@Component({
  selector: 'app-books',
  templateUrl: './books.component.html',
  styleUrls: ['./books.component.scss']
})
export class BooksComponent implements OnInit, OnDestroy {

  public frame: BookIndexFrame;
  protected logger: Logger;
  private sub: Array<Subscription> = [];

  constructor(
    protected data: DataService,
    loggerSrvc: LoggerService,
    private lang: LanguageService,

  ) {
    this.logger = new Logger(loggerSrvc, this.constructor.name);
  }

  ngOnInit() {
    this.sub.push(
      this.lang.lang().asObservable().pipe(
        mergeMap(a => this.data.getIndex("0")))

        .subscribe(
          data => this.processIndex(data),
          error => this.processIndexError(error)
        )
    );
  }
  ngOnDestroy() {
    this.sub.forEach(value => value.unsubscribe());
  }
  protected processIndex(index: IndexItem): void {
    this.frame = new BookIndexFrame(index)
  }

  protected processIndexError(error: any): void {
    this.logger.error('Error loading Rulebook index. Error: ', error);
  }
}
